import {useEffect, useState} from "react";
import './index.css'
import FormButton from "../../../components/form-button";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";
import StringHelper from "../../../helpers/string-helper";
import InformationToast from "../../../components/toast/InformationToast";
import associateServices from "../../../services";
import SvgIcon from "../../../components/svg-icon";

const CampaignCreateModal = props => {

    const {handleClose} = props
    useEffect(() => {
        const bdy = document.body
        bdy.classList?.add('modal-open')

        const mdl = document.getElementById('campaign-modal')
        mdl.classList?.add('show')

        mdl.style.display = 'block'
        mdl.style.backgroundColor = 'rgba(0,0,0,.7)'

    }, [])

    const {t} = useTranslation();
    const [submitting, setSubmitting] = useState(false)


    const [name, setName] = useState('')
    const [secret, setSecret] = useState('')

    const handleStoreCampaign = () => {

        setSubmitting(true)
        associateServices.storeCampaign({
            name, secret
        }).then(handleStoreCampaignResponse)

    }

    const handleStoreCampaignResponse = response => {

        if (response?.status !== 200 || response?.errors) {
            toast.error(t(`api-notifications.${response?.errors}`))
            return setSubmitting(false)
        }

        //
        setSubmitting(false)
        handleClose()

        toast(<InformationToast
            icon={'ti-check'}
            title={t(`affiliate.referred-user.stored`)}
            message={t(`affiliate.referred-user.stored-desc`)}
        />)

        window.location?.reload()
        // store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
    }


    // const handleClose = () => store.dispatch(GLOBAL_ACTIONS.setModalTypeAction(null))
    return (
        <div
            className="modal fade"
            id="campaign-modal"
            tabIndex={-1}
            aria-labelledby="campaign-modal"
            aria-hidden="true"
            onClick={handleClose}
        >
            <div className="modal-dialog modal-dialog-centered" onClick={e => e.stopPropagation()}>
                <div className="modal-content">
                    <div className="modal__content">
                        <div className="modal__head">
                            <h6 className="modal__title">
                                {t('affiliate.campaigns.create-campaign')}
                            </h6>
                            <button
                                className="modal__close"
                                type="button" onClick={handleClose}
                            >
                                <SvgIcon id={'x'}/>
                            </button>
                        </div>


                        <div className="modal__form">
                            <div className="form__group">
                                <label htmlFor="" className="form__label">
                                    {t('affiliate.referred-user.name')}

                                    <b>*</b>
                                </label>
                                <input
                                    value={name}
                                    maxLength={16}
                                    onChange={e => setName(StringHelper.getStringEN(e.target.value?.replace(/\s/g, '')))}
                                    type="text" className="form__input"/>
                            </div>


                            <div className="form__group">
                                <label htmlFor="" className="form__label">
                                    {t('affiliate.campaigns.table.secret')}
                                    <b>*{t('general.optional')}</b>
                                </label>
                                <input
                                    value={secret}
                                    maxLength={64}
                                    onChange={e => setSecret(StringHelper.getStringEN(e.target.value))}
                                    type="text" className="form__input"/>
                            </div>


                            <FormButton
                                disabled={submitting || !name}
                                loading={submitting}
                                onClick={handleStoreCampaign}
                                label={t('affiliate.referred-user.store')}
                            />

                        </div>
                    </div>
                </div>
            </div>
        </div>


    )

}

export default CampaignCreateModal
